import { BeforeRequestMiddleware } from '../types';

/**
 * Return `true` if `obj` is a plain object.
 *
 * A plain object is an object literal which prototype is the same as `{}`.
 */
function isPlainObject(obj: any): boolean {
  return (
    obj !== null &&
    typeof obj === 'object' &&
    Object.getPrototypeOf(obj) === Object.getPrototypeOf({})
  );
}

/**
 * Serialize a JSON request `body` and set the appropriate `content-type`
 * header.
 */
export const requestBody: BeforeRequestMiddleware = async (init) => {
  if (isPlainObject(init.body) || Array.isArray(init.body)) {
    try {
      init.body = JSON.stringify(init.body);
      init.headers.set('content-type', 'application/json;charset=utf-8');
    } catch (err) {
      // Silent error
    }
  }
  return init;
};
